// base64ChunkHandler.js
const chunkMap = new Map();
const metaMap = new Map();

function assembleBase64Chunks(id) {
  const chunks = chunkMap.get(id);
  const { mime, width,height, type } = metaMap.get(id);

  const base64 = chunks.join("");
  fetch(`data:${mime};base64,${base64}`)
    .then((res) => res.blob())
    .then((blob) => {
      const url = URL.createObjectURL(blob);
      window.dispatchEvent(
        new CustomEvent("image-blob-ready", { detail: { id, url, type ,blob ,base64,width,height} })
      );
      chunkMap.delete(id);
      metaMap.delete(id);
    });
}

export function onBase64Chunk({ Id, Index, Total, Chunk, Mime,Width ,Height, Type }) {
  if (!chunkMap.has(Id)) chunkMap.set(Id, []);
  if (!metaMap.has(Id)) metaMap.set(Id, { total: Total, mime: Mime, width:Width,height:Height, type: Type });

  const arr = chunkMap.get(Id);
  arr[Index] = Chunk;

  if (arr.filter(Boolean).length === Total) {
    assembleBase64Chunks(Id);
  }
}





const CHUNK_SIZE = 64 * 1024; // 64KB

export async function uploadBase64ToBridge({ base64String, id, folderName, originalFileName }) {
  const key = `${folderName}_${id}_${Date.now()}`;

  window.chrome.webview.hostObjects.sync.penChart.StartUpload(
    key,
    id,
    originalFileName,
    folderName
  );

  const base64 = base64String.includes("base64,")
    ? base64String.split(",")[1]
    : base64String;

  const totalChunks = Math.ceil(base64.length / CHUNK_SIZE);
  for (let i = 0; i < totalChunks; i++) {
    const start = i * CHUNK_SIZE;
    const end = Math.min(start + CHUNK_SIZE, base64.length);
    const chunk = base64.slice(start, end);

    window.chrome.webview.hostObjects.sync.penChart.AppendChunk(key, chunk);
  }

  window.chrome.webview.hostObjects.sync.penChart.Finish(key);
}
